import React, { useState } from 'react';
import { ATMForm } from 'shared-it-appmod-ui';
import {
  IFireDispatch,
  FireDispatchValidationShapes,
} from 'src/models/fire-fighting-dispatch.model';
import FormError from 'src/components/atoms/form-error/form-error.component';
import DispatchUserInformationForm from './fire-dispatch-user-fields/fire-dispatch-user-fields.component';
import DispatchInformationForm from './dispatch-information-form/dispatch-information-form.component';
import FlightInformationForm from './flight-information-form/flight-information-form.component';
import FireInformationForm from './fire-information-form/fire-information-form.component';
import FireDispatchStatusForm from './fire-dispatch-status-form/fire-dispatch-status-form.component';

interface IProps {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: IFireDispatch;
  handleSubmit: (data: IFireDispatch) => void;
}

const NewFireDispatchForm: React.FC<IProps> = ({
  formRef,
  handleSubmit,
  defaultValues,
}) => {
  const [status, setStatus] = useState<any>(defaultValues?.status);

  return (
    <ATMForm
      ref={formRef}
      mode="onChange"
      validationSchema={FireDispatchValidationShapes(status)}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
    >
      {({ control, errors }) => {
        const onStatusChange = control.watchInternal('status');
        setStatus(onStatusChange);

        return (
          <>
            <FormError errors={errors} />
            <DispatchUserInformationForm
              control={control}
              errors={errors}
              dispatchId={defaultValues?.dispatchId}
            />
            <DispatchInformationForm control={control} errors={errors} />
            <FlightInformationForm
              control={control}
              errors={errors}
              isEdit={
                defaultValues?.dispatchId !== null &&
                defaultValues?.dispatchId !== undefined
              }
            />
            <FireInformationForm control={control} errors={errors} />
            <FireDispatchStatusForm control={control} errors={errors} />
          </>
        );
      }}
    </ATMForm>
  );
};

export default NewFireDispatchForm;
